import React from "react";
import { connect } from "react-redux";

const DocumentReviewSpotlightCard = ({ active, entities, entityTypeInfo }) => {
  const Title = ({ entity, index }) => (
    <div
      data-belongsto="metalens-dropdown"
      className="documentreview-spotlight-card-title">
      {index}. {entity.entity_type}
    </div>
  );

  if (active) {
    return (
      <div className="documentreview-spotlight-card-body-active">
        <div className="documentreview-spotlight-card-body-title">
          <span
            role="img"
            aria-label="spotlight-icon"
            className="documentreview-spotlight-card-body-title-icon">
            &#128294;
          </span>
          IN THE SPOTLIGHT
        </div>
        {/* Title */}
        {entities &&
          entities.map((en, i) => (
            <div className="documentreview-spotlight-card-body">
              {
                <Title
                  key={`${en.id}-entity-title`}
                  index={i + 1}
                  entity={en}
                />
              }
              <p className="documentreview-spotlight-card-description">
                {entityTypeInfo &&
                  entityTypeInfo[en.entity_type] &&
                  entityTypeInfo[en.entity_type].description}
              </p>
            </div>
          ))}
      </div>
    );
  }
  return (
    <div className="documentreview-spotlight-card-body">
      {entities &&
        entities.map((en, i) => (
          <Title id={`${en.id}-entity-title`} index={i + 1} entity={en} />
        ))}
    </div>
  );
};

const mapStateToProps = ({ MetalensStore: { entityTypeInfo } }) => ({
  entityTypeInfo,
});

export default connect(mapStateToProps)(DocumentReviewSpotlightCard);



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewClauses/DocumentReviewSpotlightCard.js